<template lang="pug">
  v-card(style="border-radius:8px;")
    v-row(
      no-gutters 
      justify="center" 
      style="background:var(--card-round-header-v2)"
    )
      h4.white--text {{ title }}
    v-row(
      no-gutters 
      justify="center"
    )
      h4 {{ value }}
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: null
    },
  }
}
</script>